import { apiClient } from "../apiClient";

export const TIEU_DE_BAO_CAO_ENDPOINT = "tieu-de-bao-cao";
export const tieuDeBaoCaoApi = {
    SelectByUserId: (userId: string) => apiClient.get(`user/${userId}/${TIEU_DE_BAO_CAO_ENDPOINT}`),
    DeleteByUserId: (userId: string) => apiClient.delete(`user/${userId}/${TIEU_DE_BAO_CAO_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(`${TIEU_DE_BAO_CAO_ENDPOINT}`, payload),
    Update: (payload: any) => apiClient.put(`${TIEU_DE_BAO_CAO_ENDPOINT}`, payload),
}
